import { buildUseStyles, useTheme } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import useMobileLayout from 'Hooks/useMobileLayout';
import MetaTable from 'Components/UI/Meta/MetaTable';
import PropTypes from 'prop-types';
import React from 'react';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import { content, root } from 'Views/Page/Content/Templates/Profile/Templates/ProfileTemplate/Subpages/subpageClasses';
import BillingDetailsTableMobileRow from './BillingDetailsTableMobileRow/BillingDetailsTableMobileRow';

const useStyles = buildUseStyles('BillingDetailsTable', (theme) => ({
  root: root(theme),
  content: content(theme),
  table: {
    margin: theme.spacing(6, 0, 5, 0),
  },
  tableHeader: {
    '& th': {
      backgroundColor: theme.palette.common.white,
      color: theme.palette.facet.darkGray,
    },
  },
  tableCell: {
    padding: theme.spacing(0.5),
    marginRight: theme.spacing(2),
    '& h5': {
      fontSize: theme.typography.fontSizePt875Rem,
      color: theme.palette.facet.darkGray,
      fontWeight: theme.typography.fontWeightBold,
    },
  },
  billingDetailsTableMobile: {
    margin: theme.spacing(4, 0),
  },
  paymentFailedRow: {
    '&, & h5, & td, & p': {
      color: theme.palette.facet.mediumGray,
      fontWeight: theme.typography.fontWeightLight,
      fontStyle: 'italic',
    },
  },
}));

const BillingDetailsTable = ({
  billingDetailsPageResource,
}) => {
  const theme = useTheme();
  const classes = useStyles(theme);
  const isMobile = useMobileLayout();
  const invoiceCollection = billingDetailsPageResource.attr('invoices');
  const invoiceList = invoiceCollection.resources().list();

  if (isMobile) {
    return (
      <Box className={classes.billingDetailsTableMobile} test={'billing-page-payment-source'}>
        {invoiceList.map(invoice => (
          <BillingDetailsTableMobileRow resource={invoice} />
        ))}
      </Box>
    );
  }

  return (
    <Box test={'billing-page-table'}>
      <MetaTable
        tableMetaOverrideSetName={'BillingDetailsProfileSubpageMetaOverride'}
        className={classes.table}
        collection={invoiceCollection}
        columns={[
          { name: 'date', style: { minWidth: '90px' } },
          { name: 'descriptions', style: { minWidth: '150px' } },
          { name: 'membershipPeriod', style: { minWidth: '150px' } },
          { name: 'paymentMethods', style: { minWidth: '210px' } },
          { name: 'subTotals', style: { minWidth: '90px' } },
          { name: 'status', style: { minWidth: '90px' } },
          { name: 'total', style: { minWidth: '90px' } },
        ]}
        HeadProps={{
          className: classes.tableHeader,
        }}
        CellProps={{
          className: classes.tableCell,
        }}
        disablePagination
      />
    </Box>
  );
};

BillingDetailsTable.defaultProps = {
};

BillingDetailsTable.propTypes = {
  billingDetailsPageResource: PropTypes.object.isRequired,
};

export default BillingDetailsTable;
